import {
  ApiNotificationStatus,
  ApiNotificationTargetType,
} from "../../../../services/notificationApi";

export const notificationStatus = (status: ApiNotificationStatus) => {
  switch (status) {
    case ApiNotificationStatus.Draft: return { label: "Draft", className: "draft" };
    case ApiNotificationStatus.Scheduled: return { label: "Scheduled", className: "scheduled" };
    case ApiNotificationStatus.Sending: return { label: "Sending", className: "sending" };
    case ApiNotificationStatus.Sent: return { label: "Sent", className: "sent" };
    case ApiNotificationStatus.Failed: return { label: "Failed", className: "failed" };
    default: return { label: "Unknown", className: "unknown" };
  }
};

export const notificationTarget = (targetType: ApiNotificationTargetType) => {
  switch (targetType) {
    case ApiNotificationTargetType.All: return "All recipients";
    case ApiNotificationTargetType.Segment: return "Segment";
    case ApiNotificationTargetType.UserIds: return "Selected users";
    case ApiNotificationTargetType.ExcludeUserIds: return "Users excluding selection";
    case ApiNotificationTargetType.Vendors: return "Vendors";
    case ApiNotificationTargetType.Users: return "Users";
    case ApiNotificationTargetType.Emails: return "Specific emails";
    case ApiNotificationTargetType.Location: return "Location";
    default: return "—";
  }
};

export const formatNotificationDate = (value: string | null | undefined) => {
  if (!value) return "—";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "—";
  return `${new Intl.DateTimeFormat("en-US", { month: "long", day: "numeric", year: "numeric" }).format(date)}, ${new Intl.DateTimeFormat("en-US", { hour: "numeric", minute: "2-digit" }).format(date)}`;
};
